// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import VueResource from "vue-resource";
Vue.use(VueResource);

require("./util/configHttp");
require("./util/filter");

// By default we import all the components.
// Only reserve the components on demand and remove the rest.
// Style is always required.
import {
    Style,
    Button,
    CheckboxGroup,
    Radio,
    Input,
    Textarea,
    Select,
    Rate,
    Popup,
    Toast,
    Picker,
    DatePicker,
    Dialog,
    Scroll,
    Upload
} from "cube-ui";

import App from "./App";
import router from "./router";

Vue.use(Button);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(Input);
Vue.use(Textarea);
Vue.use(Select);
Vue.use(Rate);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(DatePicker);
Vue.use(Dialog);
Vue.use(Scroll);
Vue.use(Upload);
Vue.use(Popup);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    template: "<App/>",
    components: { App }
});
